import React, { useState } from 'react';
import "../../iqac.css"
import TopNav from '../../../../../Components/TopNav';
import Navbar from '../../../../../Components/Navbar';
import DropdownNav from '../../../../../Components/DropdownNav';
import Footer from '../../../../../Components/Footer';
import Example from '../../../../../Components/Example';
import ScrollToTop from 'react-scroll-to-top';

const AQARREPORTS = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className='navbar-area'>
        <div className='aqar-image'>
          <div className='image-cover'>

          </div>
        </div>

      </div>

      {/* This iqac details part */}

      <div className='iqac-details'>
        <div className='iqac-header'>
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
          <h1 className='iqac-obj-tit'>AQAR REPORTS</h1>
        </div>
      </div>

      {/* This is the body part of the iqac Objectives */}

      <div className='iqac-obj-det'>
        <button onClick={() => setIsOpen(e => !e)}           style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}>AQAR REPORTS of the IQAC</button>
        {
          isOpen && (
            <div className='ssr-items'>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/aqar/AQAR-2010-2011.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2010-2011 AQAR REPORTS</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/aqar/AQAR-2011-2012.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2011-2012 AQAR REPORTS</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/aqar/AQAR-2012-2013.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2012-2013 AQAR REPORTS</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/aqar/AQAR-2013-2014.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2013-2014 AQAR REPORTS</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/aqar/AQAR-2014-2015.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2014-2015 AQAR REPORTS</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/aqar/AQAR-2015-2016.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2015-2016 AQAR REPORTS</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/aqar/AQAR-2016-2017.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2016-2017 AQAR REPORTS</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/aqar/AQAR%20-%202017-2018.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2017-2018 AQAR REPORTS</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/aqar/AQAR-2018-2019.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2018-2019 AQAR REPORTS</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/aqar/AQAR-2019-2020.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2019-2020 AQAR REPORTS</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/aqar/AQAR-2020-2021.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2020-2021 AQAR REPORTS</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/aqar/AQAR-2021-2022.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2021-2022 AQAR REPORTS</h3>
                  </a>
                </div>
              </div>

            </div>
          )

        }

      </div>


      <Footer />
    </div>
  );
}

export default AQARREPORTS;
